import { format } from "date-fns";
import type {
  IProduct,
  IPromoProduct,
  ICatalogBFFListingGood,
} from "../unit-catalog.types";

export function formatPromoProduct(product: IPromoProduct): IProduct {
  return {
    id: product.id,
    title: product.name,
    link: product.url,
    image: product.imageUrl,
    badge: product.discountCategory,
    price: product.price
      ? formatNumberWithSpaces(product.price / 100)
      : undefined,
    oldPrice: product.oldPrice
      ? formatNumberWithSpaces(product.oldPrice / 100)
      : undefined,
    salePercent: product.discountLabel
      ? String(product.discountLabel)
      : undefined,
    adult: false,
    salePeriod: !product.endDate ? "" : formatSalePeriod(product.endDate),
    progressiveDiscountVariants: product.progressiveDiscount,
    progressiveDiscountType: product.progressiveDiscountType,
    startDate: product.startDate,
    endDate: product.endDate,
    discountType: product.discountType,
    discountValue: product.discountValue,
    ratings: product.ratings,
    description: product.description,
    discountCategory: product.discountCategory,
    erid: product.erid || "",
    eridInfo: product.eridInfo || "",
  };
}

export function formatCatalogBFFListingGood(
  product: ICatalogBFFListingGood,
): IProduct {
  return {
    id: String(product.id),
    title: product.name,
    link: product.url,
    image: (product.gallery || []).filter((i) => i.type === "IMAGE")[0]?.url,
    price: String(product.price / 100),
    profit: product.profit ? String(product.profit / 100) : "",
    oldPrice: String(
      product.promotion.oldPrice ? product.promotion.oldPrice / 100 : "",
    ),
    salePercent: product.promotion?.discountPercent
      ? `-${product.promotion.discountPercent}%`
      : undefined,
    unit: product.weighted.shelfLabel,
    adult: product.isForAdults,
    ratings: product.ratings,
    badges: product.badges,
    weighted: product.weighted,
    isInFavorites: product.isInFavorites,
    quantity: product.quantity,
  };
}

const formatSalePeriod = (d: string) => `До ${format(d, "dd.MM")}`;

const formatNumberWithSpaces = (x: number): string => {
  const parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(",");
};

export const formatPrice = (price: number | string) => `${price}&#8202;₽`;
